<script setup>
import { ref, onMounted, reactive, onBeforeUnmount } from 'vue';
import axios from '../axios';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
// import { useRoute } from 'vue-router';
import store from "../store";

// const route = useRoute();
const url = ref(process.env.VUE_APP_API_URL);
const QuoteArray = ref([]);
const showModal = ref(false);
const selectedFile = ref(null);
const uploadError = ref('');

const aiStatusPending = ref(false);
const aiPendingMessage = ref('');
const aiPendingCount = ref(0);

const checkAIStatus = async () => {
    try {
        const response = await axios.get(url.value + 'api/ai-extraction-status');
        if (response.data && response.data.status === 'pending') {
            aiStatusPending.value = true;
            aiPendingMessage.value = response.data.message || 'Due to AI failure, PDF extraction is currently pending.';
            aiPendingCount.value = response.data.pending_count || 0;
            
            /*
            let toastMessage = aiPendingMessage.value;
            if (aiPendingCount.value > 0) {
                toastMessage += ` (${aiPendingCount.value} PDF(s) in Queue)`;
            }
            // store.commit('setErrorNotification', toastMessage);
            */
        } else {
            aiStatusPending.value = false;
            aiPendingMessage.value = '';
            aiPendingCount.value = 0;
        }
    } catch (error) {
        aiStatusPending.value = false;
        console.warn("AI status check currently unavailable:", error.response?.status || error.message);
    }
};

let statusInterval = null;

const retryingQuoteId = ref(null);

const retryQuote = async (id) => {
    if (retryingQuoteId.value) return;
    retryingQuoteId.value = id;
    isLoading.value = true;
    try {
        const response = await axios.post(url.value + 'api/retry-extraction', { id: id });
        store.commit('setSuccessNotification', response.data.message || 'PDF extracted successfully!');
        store.commit('setErrorNotification', null);
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 5000);
        await checkAIStatus();
        await fetchAllPdfs();
    } catch (error) {
        console.error('Retry error:', error.response?.data || error.message);
        const errMsg = error.response?.data?.error || 'Failed to retry extraction.';
        store.commit('setErrorNotification', errMsg);
        store.commit('setSuccessNotification', null);
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 5000);
        await checkAIStatus();
        await fetchAllPdfs();
    } finally {
        retryingQuoteId.value = null;
        isLoading.value = false;
    }
};

const rules = {
    selectedFile: { required }
};

const isLoading = ref(true);
const v$ = useVuelidate(rules, { selectedFile });


// const openModal = () => {
//     showModal.value = true;
//     uploadError.value = '';
// };

const closeModal = () => {
    showModal.value = false;
    selectedFile.value = null;
    v$.value.$reset();
};

const handleFileChange = (event) => {
    selectedFile.value = event.target.files[0];
    v$.value.$touch();
    uploadError.value = '';
    console.log('Selected PDF:', selectedFile.value);
};

const uploadPDF = async () => {
    v$.value.$validate();

    if (!selectedFile.value) {
        uploadError.value = 'Please select a PDF file.';
        return;
    }

    if (selectedFile.value.type !== 'application/pdf') {
        uploadError.value = 'Only PDF files are allowed.';
        return;
    }

    try {
        isLoading.value = true;
        const formData = new FormData();
        formData.append('pdf', selectedFile.value);

        const response = await axios.post(url.value + 'api/pdfTest', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        console.log('Upload success:', response.data);
        if (response.data && response.data.status === 'pending') {
            store.commit('setErrorNotification', response.data.message);
            store.commit('setSuccessNotification', null);
        } else {
            store.commit('setSuccessNotification', 'Test Quotation saved successfully');
            store.commit('setErrorNotification', null);
        }
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 5000);
        closeModal();
        await checkAIStatus();
        await fetchAllPdfs();
    } catch (error) {
        isLoading.value = false;
        console.error('Upload error:', error.response?.data || error.message);
        store.commit('setErrorNotification', error.response?.data?.error || 'Failed to upload PDF.');
        store.commit('setSuccessNotification', null);
        setTimeout(() => {
            store.commit('clearNotifications');
        }, 5000);
    }
};

const goToPage = (url) => {
    const page = new URL(url).searchParams.get('page');
    fetchAllPdfs(Number(page));
}

const pagination = reactive({
    current_page: 1,
    last_page: 1,
    links: [],
})


// Get Product
const lastPage = ref(1);
const currentPage = ref(1);
const fetchAllPdfs = async (page = 1) => {
    try {
        currentPage.value = page;
        const response = await axios.get(url.value + 'api/allPdfTest', {
            params: {
                page: page
            }
        });
        QuoteArray.value = response.data.data;
        lastPage.value = response.data.last_page;
        Object.assign(pagination, response.data)
        isLoading.value = false;
    } catch (error) {
        isLoading.value = false;
        console.error('Error fetching PDFs:', error.response?.data || error.message);
    }
};

const quoteDeleteId = ref(null);
const showProceedModel = ref(false);
const deleteQuote = (id)=>{
    quoteDeleteId.value = id;
    showProceedModel.value = true;
}
const confirmDeleteQuote = async () => {
    try {
        const response = await axios.post(url.value + 'api/deleteQuoteTest' ,{id: quoteDeleteId.value});
        store.commit('setSuccessNotification', "Quote Delete successfully");
        store.commit('setErrorNotification', null);
        setTimeout(() => {
        store.commit('clearNotifications');
        }, 3000);
        console.log('Delete success:', response.data);
        showProceedModel.value = false;
        fetchAllPdfs();
    } catch (error) {
        showProceedModel.value = false;
        console.error('Delete error:', error.response?.data || error.message);
        alert(error.response?.data?.error || 'Failed to delete PDF.');
        store.commit('setErrorNotification', error.response?.data?.error || 'Failed to delete PDF.');
        store.commit('setSuccessNotification', null);
        setTimeout(() => {
        store.commit('clearNotifications');
        }, 3000);
    }
};


const encode = (id) => {
    return encodeURIComponent(btoa(id.toString()));
}

onMounted(() => {
    fetchAllPdfs();
    checkAIStatus();
    statusInterval = setInterval(checkAIStatus, 60000);
});

onBeforeUnmount(() => {
    if (statusInterval) {
        clearInterval(statusInterval);
    }
});

</script>
<template>
    <div class="py-4 container-fluid ctm-mobile-padding">
        <div class="row mt-4">
            <div class="col-lg-12 mb-lg-0 mb-4">
                <div class="card p-3 p-md-5 shadow-lg rounded-xl bg-light-color text-gray-800 position-relative">
                    <div class="ctm-loader" v-if="isLoading">
                        <div class="loader" id="loader-5">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div class="card">
                        <div class="p-3 pb-0 card-header">
                            <div class="d-flex justify-content-between">
                                <h6 class="mb-2">Test Quote Management</h6>
                                <!-- <button class="upload-btn" @click="openModal">Add New Quotation </button> -->

                            </div>
                        </div>
                        <div class="overflow-x-auto table-overflow">
                            <table class="table align-items-center">
                            <thead>
                                <tr>
                                    <th class="text-start px-3">Quotation No</th>
                                    <th class="text-start px-2">Customer Name</th>
                                    <th class="text-start px-2">Date</th>
                                    <!-- <th class="text-start px-2">Item</th> -->
                                    <th class="text-start px-2">Shipping Address</th>
                                    <th class="text-start px-2">Status</th>
                                    <th class="text-start px-2">Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="QuoteArray.length > 0">
                                <tr v-for="(quotemanegement, index) in QuoteArray" :key="index">
                                    <td class="fs-14 ps-3">#{{ quotemanegement.quotation_number }}</td>
                                    <td class="fs-14 text-wrap" style="max-width: 150px;">{{ quotemanegement.customer_name }}</td>
                                    <td class="fs-14">{{ quotemanegement.shipment_date }}</td>
                                    <td class="fs-14 text-wrap" style="max-width: 250px;">
                                        <template v-if="quotemanegement.status === 'AI Failed' || quotemanegement.status === 'Error'">
                                            <span class="text-danger font-weight-bold" style="font-size: 0.8rem; white-space: pre-line; display: block; line-height: 1.2;">
                                                ⚠️ {{ quotemanegement.ship_to_address || 'AI parsed empty result or failed.' }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            {{ quotemanegement.ship_to_address }},{{ quotemanegement.ship_to_cityzip }} {{ quotemanegement.ship_to_country }}
                                        </template>
                                    </td> <!-- Static Address -->
                                    <!-- <td class="fs-14">{{ quotemanegement.subTotal }}</td> -->
                                    <td class="fs-14">
                                        <template v-if="quotemanegement.status === 'AI Failed' || quotemanegement.status === 'Error'">
                                            <button 
                                                @click="retryQuote(quotemanegement.id)" 
                                                class="btn btn-sm py-1 px-3 m-0 align-middle text-xs d-flex align-items-center gap-1 font-weight-bold"
                                                style="background-color: #f59e0b; color: white; border: none; border-radius: 4px; cursor: pointer; transition: background-color 0.2s;"
                                                onmouseover="this.style.backgroundColor='#d97706'"
                                                onmouseout="this.style.backgroundColor='#f59e0b'"
                                                :disabled="retryingQuoteId === quotemanegement.id"
                                            >
                                                <i class="fas fa-sync" :class="{'fa-spin': retryingQuoteId === quotemanegement.id}"></i>
                                                {{ retryingQuoteId === quotemanegement.id ? 'Retrying...' : 'Retry' }}
                                            </button>
                                        </template>
                                        <template v-else>
                                            <span class="status-badge" :class="{
                                                'bg-pending': quotemanegement.status === 'Pending',
                                                'bg-active': quotemanegement.status === 'Approved'
                                            }">
                                                {{ quotemanegement.status }}
                                            </span>
                                        </template>
                                    </td>
                                    <td class="fs-14">
                                        <div class="d-flex align-items-center gap-2">

                                        <router-link class="ms-2" :to="`/test-single-quotation/${encode(quotemanegement.id)}`"><svg
                                                xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#a35c2e"
                                                class="bi bi-eye" viewBox="0 0 16 16">
                                                <path
                                                d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                                <path
                                                d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                            </svg>
                                        </router-link>

                                        <button class="delete-notification"
                                            @click="deleteQuote(quotemanegement.id)"><svg
                                                xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                                                <path
                                                    d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                            </svg></button>
                                            </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="6" class="text-center">No data available</td>
                                </tr>
                            </tbody>

                        </table>
                        </div>
                        
                        <div class="peginationMain">
                            <nav class="pagination" v-if="lastPage > 1">
                                <a href="#" class="previous" :class="{ disabled: pagination.current_page === 1 }"
                                    @click.prevent="pagination.current_page !== 1 && goToPage(pagination.links[0].url)">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M18 10a.75.75 0 0 1-.75.75H4.66l2.1 1.95a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 1 1 1.02 1.1l-2.1 1.95h12.59A.75.75 0 0 1 18 10Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Previous
                                </a>
                                <ul class="pages">
                                    <li v-for="(link, index) in pagination.links.slice(1, -1)" :key="index" class="page">
                                        <a href="#" v-if="link.url" :class="{ current: link.active }"
                                            @click.prevent="goToPage(link.url)" v-html="link.label"></a>
                                        <span v-else-if="link.label === '...'" class="dots">…</span>
                                    </li>
                                </ul>
                                <a href="#" class="next"
                                    :class="{ disabled: pagination.current_page === pagination.last_page }"
                                    @click.prevent="pagination.current_page !== pagination.last_page && goToPage(pagination.links[pagination.links.length - 1].url)">
                                    Next
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M18 10a.75.75 0 0 1-.75.75H4.66l2.1 1.95a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 1 1 1.02 1.1l-2.1 1.95h12.59A.75.75 0 0 1 18 10Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </a>
                            </nav>
                        </div>


                    </div>
                </div>
            </div>

        </div>

    </div>

    <div v-if="showModal" class="modal-overlay">
        <div class="modal-container">
            <div class="modal-header">
                <h5 class="modal-title">Add New Quotation</h5>
                <button class="close-button" @click="closeModal">&times;</button>
            </div>
            <div class="modal-body">
                <input type="file" class="form-control" accept="application/pdf" @change="handleFileChange" />
                <div v-if="uploadError" class="text-danger mt-2">{{ uploadError }}</div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-bg-yellow" @click="closeModal">Cancel</button>
                <button class="btn btn-bg" @click="uploadPDF">Save</button>
            </div>
        </div>
    </div>


    <div v-if="showProceedModel" class="modal-overlay">
        <div class="modal-container">
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
                <button class="close-button" @click="showProceedModel = false">&times;</button>
            </div>
            <div class="modal-body">
                <p class="mb-0">are you sure you want to delete a quotation.?</p>
            </div>
            <div class="modal-footer">
                <button class="btn btn-bg-yellow" @click="showProceedModel = false">No</button>
                <button class="btn btn-bg" @click="confirmDeleteQuote">Yes</button>
            </div>
        </div>
    </div>


</template>

<style scoped>
/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}

.modal-container {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    max-width: 90%;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    margin-top: 10px;
    margin-bottom: 10px;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
}

.close-button {
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
}


.peginationMain {
    padding: 40px 0px;
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}


.pagination {
    display: flex;
    width: 100%;
    height: 40px;
    font-family: "Inter", sans-serif;
    color: #6b7280;
    justify-content: space-between;
    border-top: 1px solid #e5e7eb;
}

.pagination>a:last-of-type {
    text-align: right;
}

.pagination a,
.pagination .dots {
    color: #000;
    display: block;
    padding: 16px 16px 0;
    text-decoration: none;
    margin-top: -1px;
    border-top: 2px solid transparent;
}

.pagination .dots {
    color: #000;
    font-weight: 500;
}

.pagination a:hover {
    border-color: #d1d5db;
    color: #374151;
}

.pagination a:active,
.pagination a.current {
    border-color: #f59e0b;
    color: #374151;
}

.pagination>a {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.pagination>a:first-of-type {
    padding: 16px 4px 0 0;
}

.pagination>a:last-of-type {
    padding: 16px 0 0 4px;
}

.pagination>a>svg {
    width: 1.25rem;
    height: 1.25rem;
}

.pagination>a:first-of-type>svg {
    margin-right: 20px;
}

.pagination>a:last-of-type>svg {
    margin-left: 20px;
}

.pagination>a.next>svg {
    transform: scaleX(-1);
}

.pagination .pages {
    display: flex;
    width: 50%;
    max-width: 468px;
    margin: 0;
    padding: 0;
    list-style-type: none;
    justify-content: space-evenly;
}

.pagination a.disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
    border-color: transparent !important;
    color: #9ca3af;
}

.pagination a.disabled svg {
    pointer-events: none;
    opacity: 0.5;
}



@media (max-width: 735px) {
    .pagination .pages {
        display: none;
    }
}

.page {}
</style>
